import { ca } from '@cian/analytics';

import { IAgentSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { getCustomUrl } from '../../../utils/tracking';

export function trackResponseSuccess(
  opener: 'agent' | 'floating' | undefined, offer: IOfferSchema, agent: IAgentSchema | null,
) {
  ca('event', {
    action: `CallBack_popup_send_${opener}_block`,
    category: 'card',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
  });
}
